import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
export const AccommodationCardAddress = t0 => {
  const $ = _c(3);
  const {
    address
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><MaterialIcon name="location_on" variant="outlined" className="text-on-surface-medium-emphasis !text-[16px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== address) {
    t2 = <div className="text-extra-caption text-on-surface-medium-emphasis flex items-center justify-start gap-1 font-[400]">{t1}{address}</div>;
    $[1] = address;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};